import { render, staticRenderFns } from "./onlineExhibitionTopics.vue?vue&type=template&id=4978e078&scoped=true"
import script from "./onlineExhibitionTopics.vue?vue&type=script&lang=js"
export * from "./onlineExhibitionTopics.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/onlineExhibitionTopics.css?vue&type=style&index=0&id=4978e078&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4978e078",
  null
  
)

export default component.exports